export default "__VITE_ASSET__CwMgDJIX__"